'use strict';

import {Dialog} from './dialog.js';

/**
 * MC benefits promo PLP.
 *
 * GA tracking (DEV-18300): the PLP is opened from several places, and each one has to be
 * reported separately. Callers pass the touchpoint through show(), so the view event is
 * always emitted from one place and can never double-fire.
 */
export class DialogMcbenefitsplp extends Dialog {
	// Reported with mc_benefits_plp_views. "automatic" covers any open that does not come
	// from a named touchpoint, including the queued auto-open on the first MC visit.
	static TOUCHPOINT_AUTOMATIC = 'automatic';

	constructor(component_key) {
		super(component_key);
		this.$cta = jQuery('.js-mcbenefitsplp_cta');
		this.touchpoint = null;
	}

	init() {
		super.init();
		// Move the dialog out of the page column so its z-index competes globally.
		if (this.$dialog.length && !this.$dialog.parent().is('body')) {
			this.$dialog.appendTo('body');
		}
	}

	/**
	 * @param {string} [touchpoint] mc_benefits_touchpoint value for this open. Defaults to
	 *   "automatic" so a caller that forgets to pass one still reports something.
	 */
	show(touchpoint) {
		// The base class binds the trigger with show.bind(this), so this also arrives as a
		// click handler whose first argument is the event. Only strings are touchpoints.
		this.touchpoint = typeof touchpoint === 'string' ? touchpoint : null;
		// Forward the value: the base class replays its arguments after a lazy fetch, so
		// dropping it here would re-enter show() with nothing and clear the touchpoint.
		super.show(touchpoint);
	}

	/**
	 * The touchpoint for this open: an explicit caller value wins, otherwise "automatic".
	 * The queued auto-open passes no touchpoint, so it reports "automatic" too.
	 */
	resolve_touchpoint() {
		return this.touchpoint || DialogMcbenefitsplp.TOUCHPOINT_AUTOMATIC;
	}

	add_events() {
		super.add_events();
		this.$cta = jQuery('.js-mcbenefitsplp_cta');
		this.$cta.off('click.upgrade').on('click.upgrade', () => {
			this.track_click('mc_benefits_main_cta');
			this.hide();
			// A premium user already owns the benefits, so the CTA opens the wallpaper picker
			// itself instead of upselling the plan they hold.
			if (this.component.is_premium) {
				const picker = (yalwa.v.component_instances || {})['dialog_chatwallpaper'];
				if (picker && typeof picker.show === 'function') {
					picker.show();
				}
				return;
			}
			yalwa.mobile.load_pa_plan_overlay('mc_chat_wallpaper');
		});

		// The close icon is a separate target from the backdrop, and the base class hides on
		// both. Report the icon here; the backdrop handler below reports the other case.
		// component_type is "dialog", so the class is .js-dialog_close on both the icon and
		// the root, exactly as the base class binds it.
		this.$dialog.find(`.js-${this.component.component_type}_close`).on('click.track', (e) => {
			if (!jQuery(e.target).hasClass('dialog__position')) {
				this.track_click('mc_benefits_close');
			}
		});
		this.track_outside_click();
	}

	// A click on the dimmed backdrop dismisses the PLP and is reported separately from the
	// close icon. Bound here rather than in the base class so other dialogs are unaffected.
	track_outside_click() {
		this.$dialog.off('click.overlay').on('click.overlay', (e) => {
			if (e.target === e.currentTarget || jQuery(e.target).hasClass('dialog__position')) {
				this.track_click('mc_benefits_overlay');
			}
		});
	}

	on_show() {
		jQuery('html').addClass('js-no_scroll');
		setTimeout(() => {
			jQuery(`.js-${this.id}_position`).addClass('js-active');
		}, 50);
		yalwa.basics.ga.datalayer({
			event: 'mc_benefits_plp_views',
			mc_benefits_touchpoint: this.resolve_touchpoint(),
		});
	}

	track_click(click_type) {
		yalwa.basics.ga.datalayer({
			event: 'mc_benefits_plp_clicks',
			mc_benefits_click_type: click_type,
		});
	}

	on_close() {
		jQuery(`.js-${this.id}_position`).removeClass('js-active');
		jQuery('html').removeClass('js-no_scroll');
		// Clear the touchpoint so the next open does not reuse this one's label.
		this.touchpoint = null;
	}
}